import { render } from "./AllDocuments.vue?vue&type=template&id=b1a98302"
import script from "./AllDocuments.vue?vue&type=script&lang=js"
export * from "./AllDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__